import {MC_Constants} from "../MC_Constants";

export class MC_Parent_Template {

    // Fields
    public id: string;
    public roles: MC_Template_Role[];

    // Create recipe from data
    constructor(data: any) {
        this.id = MC_Constants.parseNullableField<string>(data, "id", "UNKNOWN_ID");
        const rolesData: any[] = MC_Constants.parseNullableField<any[]>(data, "roles", []);
        this.roles = rolesData.map((x: any) => new MC_Template_Role(x));
    }

    // Returns the template role if available, or null
    public getRole(roleID: string): MC_Template_Role | null {
        for (let role of this.roles) {
            if (role.id === roleID) {
                return role;
            }
        }
        // Not found
        return null;
    }

}

export class MC_Template_Role {

    public id: string;
    public name: string;
    public deviceType: string;
    public minCount: number;
    public maxCount: number;

    // Constructor to accept JSON object
    constructor(data: any) {
        this.id = MC_Constants.parseNullableField<string>(data, "id", "UNKNOWN_ID");
        this.name = MC_Constants.parseNullableField<string>(data, "name", "UNKNOWN");
        this.deviceType = MC_Constants.parseNullableField<string>(data, "device_type", "UNKNOWN");
        this.minCount = MC_Constants.parseNullableField<number>(data, "min_count", -1);
        this.maxCount = MC_Constants.parseNullableField<number>(data, "max_count", -1);
    }

}

